import { FILTER_TYPE } from 'components/FiltersBlock/types';

export const STAGE_FILTER = (structure?: number | undefined) => {
  return {
    label: 'Этап проверки',
    name: 'stage',
    type: FILTER_TYPE.SELECT,
    apiUrl: structure
      ? `/api/standards/structures/stages/?page=1&structure=${structure}`
      : '/api/standards/structures/stages/',
  };
};

export const STAGE_FILTER_ONLY_CALL = {
  label: 'Этап',
  name: 'stage',
  type: FILTER_TYPE.SELECT,
  apiUrl: '/api/standards/structures/stages/?only-calls=true',
};
